var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGestionAlerta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1437_74819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 5,
    width: 11,
    height: 11
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18407 10.8405V8.69365C8.18407 7.28119 7.03516 6.13485 5.62015 6.13485C4.20513 6.13485 3.05622 7.28119 3.05622 8.69365V10.8405L2.27579 12.7877H8.96962L8.18919 10.8405H8.18407ZM7.60066 13.8113C7.37292 14.6941 6.57202 15.3465 5.61758 15.3465C4.66315 15.3465 3.86225 14.6941 3.63451 13.8113H0.755859L2.02759 10.6409V8.69365C2.02759 6.7157 3.63451 5.11133 5.61758 5.11133C7.60066 5.11133 9.20759 6.7157 9.20759 8.69365V10.6409L10.4793 13.8113H7.60066ZM4.73224 13.8113C4.9088 14.1183 5.23888 14.323 5.61758 14.323C5.99629 14.323 6.32638 14.1183 6.50294 13.8113H4.72968H4.73224Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1437_74819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7627 3.83105H-0.519531V16.6251H11.7627V3.83105Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1437_74819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 2,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37397 6.08877C10.2784 6.08877 11.0116 5.35557 11.0116 4.45112C11.0116 3.54668 10.2784 2.81348 9.37397 2.81348C8.46953 2.81348 7.73633 3.54668 7.73633 4.45112C7.73633 5.35557 8.46953 6.08877 9.37397 6.08877Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1437_74819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.3777 1.44922H6.37305V7.45392H12.3777V1.44922Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1437_74819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 4,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63765 6.08877C2.54209 6.08877 3.27529 5.35557 3.27529 4.45112C3.27529 3.54668 2.54209 2.81348 1.63765 2.81348C0.733199 2.81348 0 3.54668 0 4.45112C0 5.35557 0.733199 6.08877 1.63765 6.08877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1437_74819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.64142 1.44922H-1.36328V7.45392H4.64142V1.44922Z",
    fill: "#7B7B7B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1437_74819",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 5,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52632 3.92861C6.43076 3.92861 7.16396 3.19541 7.16396 2.29097C7.16396 1.38652 6.43076 0.65332 5.52632 0.65332C4.62187 0.65332 3.88867 1.38652 3.88867 2.29097C3.88867 3.19541 4.62187 3.92861 5.52632 3.92861Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1437_74819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.53009 -0.711914H2.52539V5.29279H8.53009V-0.711914Z",
    fill: "#7B7B7B"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGestionAlerta);
export default __webpack_public_path__ + "static/media/icon-gestion-alerta.40c04b0b.svg";
export { ForwardRef as ReactComponent };